import React, { Dispatch, SetStateAction } from "react";
import { OTPInput as CustomOTPInput } from "../../../components/UI";

type OTPInputProps = {
    otp: string;
    setOtp: Dispatch<SetStateAction<string>>;
}

export function OTPInput({ setOtp }: OTPInputProps) {
    return <CustomOTPInput label="Enter OTP" onOtpComplete={(value) => setOtp(value)} />
}